const auction_adding = {
  select_date: "Datum auswählen",
  operation_time: "Vorgangszeit",
  select_time: "Uhrzeit auswählen",
  select_date_first: "Wählen Sie zuerst ein Datum aus",
  price_per_km: "Preis pro Kilometer",
  max_surcharges: "Die maximale Anzahl von Zuschlägen beträgt 10",
  min_value: "Der Mindestwert beträgt",
  max_value: "Der Höchstwert beträgt",
  no_krs: "Sie können keine Auktion ohne CEIDG-Dokumente hinzufügen.",
  surcharge_error: "Der Titel des Zuschlags darf maximal 200 Zeichen haben. Der Zuschlagswert muss kleiner als 1.000.000.000 sein.",
  distance: "Entfernung",
  license: "Lizenz erforderlich",
  flat_rate: "Pauschalpreis",
  payment_deadline: "Zahlungsfrist",
  pick_currency: "Währung auswählen",
  address_not_specific: "Diese Adresse ist nicht genau genug. Bitte geben Sie eine genauere Adresse an.",
  doc_nr: "Auftragsnummer",
  settings: "Auktionseinstellungen",
  default: "Standard-Zahlungsfrist",
  threshold: "Mindestgebotsschritt (optional)",
  default_threshold: "Der Standardwert für den Gebotsschritt beträgt 1",
  threshold_placeholder: "Gebotsschritt eingeben",
  add: "Auktion hinzufügen",
  pick_start_point: "Startpunkt auswählen",
  pick_end_point: "Zielpunkt auswählen",
  add_middle_point: "Zwischenpunkt hinzufügen",
  choose_middle_point: "Zwischenpunkt auswählen",
  load_error_1: "Mindestens eine Ladung ist erforderlich",
  load_error_2: "Geben Sie die Frachtart an.",
  load_error_3: "Frachtdaten sind ungültig.",
  warehouse_address_error: "Die angegebene Adresse ist nicht genau genug",
  dates_chronological: "Achtung! Die Daten auf der Route sind nicht chronologisch. Um die Auktion hinzuzufügen, ordnen Sie die Daten in der richtigen Reihenfolge an.",
  cargos_empty: "Achtung! Teile der Ladung dürfen nicht leer oder null sein.",
  ramps_empty: "Achtung! Alle erforderlichen Rampen müssen ausgefüllt werden.",
  start_missing: "Alle Daten im Startpunkt müssen ausgefüllt werden.",
  middle_missing: "Alle Daten in den Zwischenpunkten müssen ausgefüllt werden.",
  end_missing: "Alle Daten im Zielpunkt müssen ausgefüllt werden.",
  operation_missing: "Alle Punkte müssen eine hinzugefügte Operation haben.",
  full_cargo_transport_info: "Der Transport umfasst die gesamte Ladung – alle Positionen werden zusammen transportiert",
  choose_address: "Adresse auswählen",
  address_placeholder: "Adresse eingeben...",
  choose_address_required: "Adresse auswählen",
  operation_date: "Vorgangsdatum",
  choose_date_required: "Datum auswählen",
  cargo_operations: "Ladungsoperationen",
  loading_all_cargo: "Gesamte Ladung verladen",
  unloading_all_cargo: "Gesamte Ladung entladen",
  full_cargo_note: "Alle Ladungsposten werden gemeinsam transportiert",
  start_date_before_end: "Das Startdatum muss vor dem Entladedatum liegen",
};
export default auction_adding;
